module.exports = __webpack_public_path__ + "static/img/TA806.10f32ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/common/problem/TA806.png
// module id = nm48
// module chunks = 0